import { api } from '../../services/api';

export interface SearchResult {
    id: string;
    type: 'employee' | 'asset' | 'document' | 'department';
    title: string;
    subtitle?: string;
    metadata?: any;
}

export const searchApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getSearchResults: builder.query<SearchResult[], string>({
            query: (q) => ({
                url: `/v1/search?q=${encodeURIComponent(q)}`,
                method: 'GET',
            }),
            transformResponse: (response: any) => response.data,
        }),
    }),
});

export const { useGetSearchResultsQuery } = searchApi;
